import LettuceTalkLogo from "../images/logo.png";
import { useState } from "react";
import SpeechBubble from "./SpeechBubble";

function DifficultTopicsQuestion(props) {
  const difficultTopics = [
    "financial",
    "medical",
    "inheritance",
    "housing",
    "legal",
    "sharing load",
    "burnout",
  ];

  const initialSelectedTopic = Object.fromEntries(
    difficultTopics.map(topic => [topic, false])
  );
  const [selectedDifficultTopics, setSelectedDifficultTopics] = useState(initialSelectedTopic);
  const [topicContext, setTopicContext] = useState("");

  const handlePreviousClick = () => {
    if (props.onPreviousClick) {
      props.onPreviousClick();
    }
  }

  const handleNextClick = () => {
    console.log(selectedDifficultTopics);
    console.log(topicContext);
    const response = {
      difficultTopics: selectedDifficultTopics,
      topicContext: topicContext,
    }
    if (props.onNextClick) {
      props.onNextClick(response);
    }
  }

  const handleTopicContextChange = (e) => {
    const { name, value } = e.target;
    setTopicContext(value);
  };

  const handleDifficultTopicClick = (topic) => {
    // Toggle selected family topic
    setSelectedDifficultTopics(previous => ({
      ...previous,
      [topic]: !previous[topic],
    }));
  }

  return (
    <div className="flex flex-col items-center rounded-lg max-w-lg p-8">
      {/* Header */}
      <img className="w-28" src={LettuceTalkLogo} alt="Lettucetalk logo, a round baby lettuce sitting on top of a parent lettuce" />

      <SpeechBubble
        header="Step 3. Difficult Topics"
        subtitle="Are there particular care topics that are hard to bring up in your family?"
      />
      <div className="card-body shadow-xl bg-white rounded-3xl mb-4">

        <div>Difficult topics for my family:</div>
        <div className="flex flex-row flex-wrap">
          {difficultTopics && difficultTopics.map((topic, index) =>
            <button
              key={index}
              className={`btn m-1 ${selectedDifficultTopics[topic] ? "btn-primary" : ""}`}
              onClick={() => handleDifficultTopicClick(topic)}
            >
              {topic}
            </button>
          )}
        </div>

        <div className="mt-4 mb-2">Any other difficult care topics?</div>
        <textarea
          placeholder="My sister lives abroad, and we've been hesitant to talk to her about contributing to our dad's care."
          value={topicContext}
          onChange={handleTopicContextChange}
          maxLength={260}
          className="textarea textarea-bordered w-full mb-4"
        />
      </div>
      <div className="flex flex-row space-x-2">
        <button
          className="btn"
          onClick={handlePreviousClick}
        >
          Previous
        </button>
        <button
          className="btn btn-primary"
          onClick={handleNextClick}
        >
          Submit
        </button>
      </div>
    </div>
  );
}

export default DifficultTopicsQuestion;


